window.THEME = window.THEME || {};

THEME.initCartSlider = function () {
  const el = document.querySelector('.cart-product-slider');
  if (el) {
    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 24,
      speed: 1500,
      navigation: {
        nextEl: '.cart-product-slider-button-next',
        prevEl: '.cart-product-slider-button-prev',
      },
      breakpoints: {},
    });
  }
};

THEME.init = function () {
  THEME.initCartSlider();
};

document.addEventListener('DOMContentLoaded', THEME.init);

window.getSlidesOffset = function (selector, container) {
  const grid = document.querySelector(container);
  const swiperEl = document.querySelector(selector);
  if (!grid || !swiperEl) return 0;
  return grid.getBoundingClientRect().left + parseInt(window.getComputedStyle(grid).paddingLeft, 10);
};
